import React, { Component } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, Alert } from 'antd';
import { connect } from "react-redux";
import * as actions from './redux/actions/auth';
import { withRouter } from 'react-router-dom';
class Login extends Component {
    state = {
        username: "",
        password: ""
    }
    layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
    };
    tailLayout = {
        wrapperCol: { lg: { offset: 6, span: 16 }, sm: { offset: 2 }, md: { offset: 6 } },
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    handleUsernameChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                username: e.target.value
            }
        });
    }
    handlePasswordChange = (e) => {
        this.setState(prevState => {
            return {
                ...prevState,
                password: e.target.value
            }
        });
    }
    submitHandler = async (event) => {
        await this.props.onAuth(
            this.state.username,
            this.state.password
        );
    };

    render() {
        let alert = null;
        if (this.props.error) {
            alert = (<Alert lg={8} sm={20} className="errorMessage" message="Username or Password invalid" type="error" />);
        }
        return (
            <Row className="container" justify="center" align="middle">
                <Col className="login-modal" lg={8} sm={20}>
                    {alert}
                    <img className="login-logo" alt="logo" src="https://live.staticflickr.com/65535/50535850016_f278011def_k.jpg" />
                    <Form
                        align="left"
                        {...this.layout}
                        className="form" justify="center"
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={this.submitHandler}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Input onChange={this.handleUsernameChange} />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                            ]}
                        >
                            <Input.Password onChange={this.handlePasswordChange} />
                        </Form.Item>

                        <Form.Item {...this.tailLayout} name="remember" valuePropName="checked">
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>

                        <Form.Item {...this.tailLayout}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        )
    }
}
const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (email, password) =>
            dispatch(actions.auth(email, password))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));